module.exports = __webpack_public_path__ + "media/images/category/dummy/bag02-7d9b8aed6a1325d336c6385139422475.jpg";